export const LOGIN_METHOD_KEY = 'loginMethod';

export enum LoginMethod {
    IAM = 'IAM',
    Identity = 'Identity',
}

